<template>
  <v-container
    fluid
    fill-height>
    <v-layout
      align-center
      justify-center>
      <v-flex
        xs12
        sm8
        lg6>
        <Card>
          <template slot="header">Login</template>
          <v-container>
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent="submit"
            >
              <v-text-field
                v-model="form.email"
                :rules="[validationRules.email]"
                label="Email"
                browser-autocomplete="username"
                prepend-icon="fa-envelope"
              />
              <v-text-field
                v-model="form.password"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                :type="showPassword ? 'text' : 'password'"
                :rules="[validationRules.required]"
                label="Password"
                browser-autocomplete="current-password"
                prepend-icon="fa-unlock-alt"
                @click:append="showPassword = !showPassword"
              />
              <v-layout column>
                <v-btn
                  :disabled="!valid"
                  type="submit"
                >
                  Submit
                </v-btn>
                <v-flex>
                  <v-layout
                    column
                    align-center
                    class="pt-4"
                  >
                    <v-flex>
                      New to the reservation system?
                      <router-link
                        :to="{ path: '/signin/signup' }"
                        class="pa-3">Sign Up
                      </router-link>
                    </v-flex>
                    <v-flex>
                      Forget your password?
                      <router-link
                        :to="{ path: '/signin/reset'}"
                        class="pa-3">Reset Password
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </Card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import vuex mapping
import { mapActions } from 'vuex'

// our new component
export default {
  name: 'LoginForm',
  data () {
    return {
      valid: false,
      showPassword: false,
      form: {
        email: null,
        password: null
      }
    }
  },
  methods: {
    ...mapActions({
      login: 'person/login'
    }),
    submit () {
      this.login(this.form).then(() => this.$router.push(this.$route.query.redirect || '/'))
    }
  }
}
</script>
